import classNames from "classnames"
import React, { useState } from "react"
import { usePopper } from "react-popper"

import { useTranslation } from "../../i18n/translate"
import ClearFilterIcon from "../../images/icons/clear.svg"
import Button from "../button/button"
import "./walk-through-tooltip.sass"

export const WalkThroughTooltip = ({
  placement = "bottom-start",
  children,
  shown,
  message,
}) => {
  const [popperElement, setPopperElement] = useState(null)
  const [wrapperElement, setWrapperElement] = useState(null)

  const [dismissed, setDismissed] = useState(false)

  const { t } = useTranslation()

  const { styles, attributes } = usePopper(wrapperElement, popperElement, {
    placement,
    strategy: "absolute",
    modifiers: [
      {
        name: "preventOverflow",
        options: {
          rootBoundary: "document",
        },
      },
      {
        name: "offset",
        options: {
          offset: [0, 10],
        },
      },
    ],
  })

  return (
    <>
      <div
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
        className={"_fp-walk-through-tooltip-popper"}
      >
        <div
          className={classNames(
            { "_fp-walk-through-tooltip--hidden": !shown || dismissed },
            "_fp-walk-through-tooltip",
          )}
        >
          {message}
          <div className="_fp-walk-through-tooltip__buttons">
            <Button
              buttonCallback={() => setDismissed(true)}
              buttonSize={"small"}
              buttonStyle={"white-blue"}
              buttonLabel={t("WALK_THROUGH_TOOLTIP-GOT_IT")}
            />
          </div>
        </div>
      </div>
      <span ref={setWrapperElement}>{children}</span>
    </>
  )
}
